import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "bes_access_token";
const AuthCtx = createContext(null);

function getToken() { return localStorage.getItem(TOKEN_KEY); }
function setToken(t) {
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
}

// Attach token to all axios calls
axios.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers = { ...(config.headers || {}), Authorization: `Bearer ${t}` };
  return config;
});

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    let cancelled = false;
    if (!getToken()) {
      setUser(false); setChecked(true); return;
    }
    axios
      .get(`${API}/auth/me`)
      .then((r) => { if (!cancelled) setUser(r.data); })
      .catch(() => { if (!cancelled) { setToken(null); setUser(false); } })
      .finally(() => { if (!cancelled) setChecked(true); });
    return () => { cancelled = true; };
  }, []);

  async function login(email, password) {
    const res = await axios.post(`${API}/auth/login`, { email, password });
    setToken(res.data.access_token);
    setUser({ id: res.data.id, email: res.data.email, name: res.data.name, role: res.data.role });
    return res.data;
  }

  async function logout() {
    try { await axios.post(`${API}/auth/logout`, {}); } catch {}
    setToken(null);
    setUser(false);
  }

  return (
    <AuthCtx.Provider value={{ user, checked, login, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() { return useContext(AuthCtx); }
